
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Vendors
import moment from "moment";

// Models
import {AdministratorPlayersProfileHealthRecordsListIndex} from "@/models/app/administrator/players/profile/health-records/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorPlayersProfileHealthRecordsListFormCreateIndexVue from "@/views/app/administrator/players/profile/health-records/list/form/create.vue";
import AdministratorPlayersProfileHealthRecordsListFormUpdateIndexVue from "@/views/app/administrator/players/profile/health-records/list/form/update.vue";
import AdministratorPlayersProfileHealthRecordsListFormRemoveIndexVue from "@/views/app/administrator/players/profile/health-records/list/form/remove.vue";
import AdministratorPlayersProfileHealthRecordsListFormLookupDocumentIndexVue from "@/views/app/administrator/players/profile/health-records/list/form/lookup-document.vue";
import AdministratorPlayersProfileHealthRecordsListFormUploadDocumentIndexVue from "@/views/app/administrator/players/profile/health-records/list/form/upload-document.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorPlayersProfileHealthRecordsListFormCreateIndexVue,
    AdministratorPlayersProfileHealthRecordsListFormUpdateIndexVue,
    AdministratorPlayersProfileHealthRecordsListFormRemoveIndexVue,
    AdministratorPlayersProfileHealthRecordsListFormLookupDocumentIndexVue,
    AdministratorPlayersProfileHealthRecordsListFormUploadDocumentIndexVue,
  },
})
export default class AdministratorPlayersProfileHealthRecordsListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: "*",
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  healthRecords: Array<AdministratorPlayersProfileHealthRecordsListIndex> = [];

  async getHealthRecords(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/health-records`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.healthRecords = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    this.formData.filter.user_id = this.$route.params.id;
    await this.getHealthRecords();
  }
}
